<div class="jjames-paginator" [class.handset]="isHandset()">
  <mat-paginator [length]="config.totalItems" [pageSize]="config.itemsPerPage" [pageIndex]="config.currentPage"
    [showFirstLastButtons]="showFirstLastButtons && !isHandset()" (page)="onPageChange($event)"
    [pageSizeOptions]="config.pageSizeOptions || [5, 10, 25, 100]" [hidePageSize]="isHandset()" [aria-label]="ariaLabel"
    panelClass="jjames-paginator-panel">
  </mat-paginator>
</div>